import type { App, Component, Plugin } from 'vue'
import GameHostView from "./components/GameHostView.vue"
import { InstantGameComponentsKey, InstantGameServiceKey, InstantGameSessionServiceKey } from './injection-keys.ts'
import type { InstantGameServiceInterface, InstantGameSessionServiceInterface } from './types'




export interface InstantGamesPluginOptions {
  games: Record<string, Component>,
  gameService: InstantGameServiceInterface,
  gameSessionService: InstantGameSessionServiceInterface
}


const InstantGamesPlugin: Plugin = {
  install(app: App, options: InstantGamesPluginOptions) {
    console.log('Installed Instant Games Plugin', options)
    app.component('GameHostView', GameHostView)
    app.provide(InstantGameComponentsKey, options.games)
    app.provide(InstantGameServiceKey, options.gameService)
    app.provide(InstantGameSessionServiceKey, options.gameSessionService)
  },
}

export default InstantGamesPlugin
